import { Input } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FormItem } from '../../components/form-item'

type InterviewInstructionsFieldProps = React.ComponentProps<typeof Input.TextArea>

export function InterviewInstructionsField(props: InterviewInstructionsFieldProps) {
    const { t } = useTranslation()

    return (
        <FormItem
            name={['data', 'feedback']}
            label={t('Additional instructions')}
            extra={t('Give Evaa extra context or guidance for the conversation and evaluation.')}
        >
            <Input.TextArea
                placeholder={t('For example: we provide training for our system. Explain this if the candidate asks.')}
                autoSize={{ minRows: 2, maxRows: 10 }}
                {...props}
            />
        </FormItem>
    )
}
